/* eslint-disable import/no-dynamic-require */

import DEAccountIcon from "./de/app-bar-account.svg";
import DELoginIcon from "./de/app-bar-login.svg";
import DESaveIcon from "./de/app-bar-save.svg";
import DELogo from "./de/app-bar-logo.svg";
import DEBeforeYourStartAsset from "./de/before-you-start.svg";
import DEClosingAsset from "./de/closing-img.svg";
import DELoadingAsset from "./de/loading-img.png";

import ARVRAccountIcon from "./arvr/app-bar-account.svg";
import ARVRLoginIcon from "./arvr/app-bar-login.svg";
import ARVRSaveIcon from "./arvr/app-bar-save.svg";
import ARVRLogo from "./arvr/app-bar-logo.svg";
import ARVRBeforeYourStartAsset from "./arvr/before-you-start.svg";
import ARVRClosingAsset from "./arvr/closing-img.png";
import ARVRLoadingAsset from "./arvr/loading-img.svg";

import MetaAccountIcon from "./meta/app-bar-account.svg";
import MetaLoginIcon from "./meta/app-bar-login.svg";
import MetaSaveIcon from "./meta/app-bar-save.svg";
import MetaLogo from "./meta/app-bar-logo.svg";
//import MetaBeforeYourStartAsset from "./meta/before-you-start.png";
import MetaBeforeYourStartAsset from "./meta/app-bar-logo.svg";
import MetaClosingAsset from "./meta/closing-img.png";
//import MetaLoadingAsset from "./meta/loading-img.png";
import MetaLoadingAsset from "./meta/app-bar-logo.svg";

import MulesoftAccountIcon from "./mulesoft/app-bar-account.svg";
import MulesoftLoginIcon from "./mulesoft/app-bar-login.svg";
import MulesoftSaveIcon from "./mulesoft/app-bar-save.svg";
import MulesoftLogo from "./mulesoft/app-bar-logo.svg";
import MulesoftBeforeYourStartAsset from "./mulesoft/before-you-start.svg";
import MulesoftClosingAsset from "./mulesoft/closing-img.svg";
import MulesoftLoadingAsset from "./mulesoft/loading-img.svg";

import NginxAccountIcon from "./nginx/app-bar-account.svg";
import NginxLoginIcon from "./nginx/app-bar-login.svg";
import NginxSaveIcon from "./nginx/app-bar-save.svg";
import NginxLogo from "./nginx/app-bar-logo.svg";
import NginxBeforeYourStartAsset from "./nginx/before-you-start.svg";
import NginxClosingAsset from "./nginx/closing-img.svg";
import NginxLoadingAsset from "./nginx/loading-img.svg";

import SalesforceAccountIcon from "./salesforce/app-bar-account.svg";
import SalesforceLoginIcon from "./salesforce/app-bar-login.svg";
import SalesforceSaveIcon from "./salesforce/app-bar-save.svg";
import SalesforceLogo from "./salesforce/app-bar-logo.svg";
import SalesforceBeforeYourStartAsset from "./salesforce/before-you-start.png";
import SalesforceClosingAsset from "./salesforce/closing-img.png";
import SalesforceLoadingAsset from "./salesforce/loading-img.png";

import SFDSAccountIcon from "./sfds/app-bar-account.svg";
import SFDSLoginIcon from "./sfds/app-bar-login.svg";
import SFDSSaveIcon from "./sfds/app-bar-save.svg";
import SFDSLogo from "./sfds/app-bar-logo.svg";
import SFDSBeforeYourStartAsset from "./sfds/before-you-start.png";
// import SFDSClosingAsset from "./sfds/closing-img.svg";
import SFDSLoadingAsset from "./sfds/loading-img.png";
import SFDSOutroAsset from "./sfds/outro-img.png";

import SFDevAccountIcon from "./sfdev/app-bar-account.svg";
import SFDevLoginIcon from "./sfdev/app-bar-login.svg";
import SFDevSaveIcon from "./sfdev/app-bar-save.svg";
import SFDevLogo from "./sfdev/app-bar-logo.svg";
import SFDevBeforeYourStartAsset from "./sfdev/before-you-start.svg";
// import SFDevClosingAsset from "./sfdev/closing-img.svg";
import SFDevLoadingAsset from "./sfdev/loading-img.svg";
import SFDevOutroAsset from "./sfdev/outro-img.svg";

import DPLAccountIcon from "./dpl/app-bar-account.svg";
import DPLLoginIcon from "./dpl/app-bar-login.svg";
import DPLSaveIcon from "./dpl/app-bar-save.svg";
import DPLLogo from "./dpl/app-bar-logo.svg";
import DPLBeforeYourStartAsset from "./dpl/before-you-start.svg";
import DPLClosingAsset from "./dpl/closing-img.svg";
import DPLLoadingAsset from "./dpl/loading-img.svg";

const config = {
  de: {
    AccountIcon: DEAccountIcon,
    LoginIcon: DELoginIcon,
    SaveIcon: DESaveIcon,
    Logo: DELogo,
    BeforeYourStartAsset: DEBeforeYourStartAsset,
    ClosingAsset: DEClosingAsset,
    LoadingAsset: DELoadingAsset
  },
  arvr: {
    AccountIcon: ARVRAccountIcon,
    LoginIcon: ARVRLoginIcon,
    SaveIcon: ARVRSaveIcon,
    Logo: ARVRLogo,
    BeforeYourStartAsset: ARVRBeforeYourStartAsset,
    ClosingAsset: ARVRClosingAsset,
    LoadingAsset: ARVRLoadingAsset
  },
  meta: {
    AccountIcon: MetaAccountIcon,
    LoginIcon: MetaLoginIcon,
    SaveIcon: MetaSaveIcon,
    Logo: MetaLogo,
    BeforeYourStartAsset: MetaBeforeYourStartAsset,
    ClosingAsset: MetaClosingAsset,
    LoadingAsset: MetaLoadingAsset
  },
  mulesoft: {
    AccountIcon: MulesoftAccountIcon,
    LoginIcon: MulesoftLoginIcon,
    SaveIcon: MulesoftSaveIcon,
    Logo: MulesoftLogo,
    BeforeYourStartAsset: MulesoftBeforeYourStartAsset,
    ClosingAsset: MulesoftClosingAsset,
    LoadingAsset: MulesoftLoadingAsset
  },
  nginx: {
    AccountIcon: NginxAccountIcon,
    LoginIcon: NginxLoginIcon,
    SaveIcon: NginxSaveIcon,
    Logo: NginxLogo,
    BeforeYourStartAsset: NginxBeforeYourStartAsset,
    ClosingAsset: NginxClosingAsset,
    LoadingAsset: NginxLoadingAsset
  },
  salesforce: {
    AccountIcon: SalesforceAccountIcon,
    LoginIcon: SalesforceLoginIcon,
    SaveIcon: SalesforceSaveIcon,
    Logo: SalesforceLogo,
    BeforeYourStartAsset: SalesforceBeforeYourStartAsset,
    ClosingAsset: SalesforceClosingAsset,
    LoadingAsset: SalesforceLoadingAsset
  },
  sfds: {
    AccountIcon: SFDSAccountIcon,
    LoginIcon: SFDSLoginIcon,
    SaveIcon: SFDSSaveIcon,
    Logo: SFDSLogo,
    BeforeYourStartAsset: SFDSBeforeYourStartAsset,
    ClosingAsset: null, // SFDSClosingAsset,
    LoadingAsset: SFDSLoadingAsset,
    OutroAsset: SFDSOutroAsset,
  },
  sfdev: {
    AccountIcon: SFDevAccountIcon,
    LoginIcon: SFDevLoginIcon,
    SaveIcon: SFDevSaveIcon,
    Logo: SFDevLogo,
    BeforeYourStartAsset: SFDevBeforeYourStartAsset,
    ClosingAsset: null, // SFDevClosingAsset,
    LoadingAsset: SFDevLoadingAsset,
    OutroAsset: SFDevOutroAsset,
  },
  dpl: {
    AccountIcon: DPLAccountIcon,
    LoginIcon: DPLLoginIcon,
    SaveIcon: DPLSaveIcon,
    Logo: DPLLogo,
    BeforeYourStartAsset: DPLBeforeYourStartAsset,
    ClosingAsset: DPLClosingAsset,
    LoadingAsset: DPLLoadingAsset
  }
};

export default config;

// const themes = {
//   de: {
//     AccountIcon: "de/app-bar-account.svg",
//     LoginIcon: "de/app-bar-login.svg",
//     SaveIcon: "de/app-bar-save.svg",
//     Logo: "de/app-bar-logo.svg",
//     BeforeYourStartAsset: "de/before-you-start.svg",
//     ClosingAsset: "de/closing-img.svg",
//     LoadingAsset: "de/loading-img.png"
//   },
//   arvr: {
//     AccountIcon: "arvr/app-bar-account.svg",
//     LoginIcon: "arvr/app-bar-login.svg",
//     SaveIcon: "arvr/app-bar-save.svg",
//     Logo: "arvr/app-bar-logo.svg",
//     BeforeYourStartAsset: "arvr/before-you-start.svg",
//     ClosingAsset: "arvr/closing-img.png",
//     LoadingAsset: "arvr/loading-img.svg"
//   }
// };

// const config = themes[process.env.REACT_APP_THEME];

// const AccountIcon = require(`./${config.AccountIcon}`);
// const LoginIcon = require(`./${config.LoginIcon}`);
// const SaveIcon = require(`./${config.SaveIcon}`);

// const Logo = require(`./${config.Logo}`);

// const BeforeYourStartAsset = require(`./${config.BeforeYourStartAsset}`);
// const ClosingAsset = require(`./${config.ClosingAsset}`);
// const LoadingAsset = require(`./${config.LoadingAsset}`);

// export default {
//   AccountIcon,
//   LoginIcon,
//   SaveIcon,
//   Logo,
//   BeforeYourStartAsset,
//   ClosingAsset,
//   LoadingAsset
// };
